import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Upload,
  message,
} from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ImageUrl } from "../../config/helper";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import swal from "sweetalert";
import { USER_AUTH } from "../../config/constants/api";
import { Post } from "../../config/api/post";
import { addUser } from "../../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

const { Option } = Select;

const Register = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState("");
  const [imageObject, setImageObject] = useState(null);
  const dispatch = useDispatch();
  const handleChangepro = (info) => {
    setLoading(true);
    getBase64(
      info?.fileList[info?.fileList?.length - 1]?.originFileObj,
      (url) => {
        setImageObject(
          info?.fileList[info?.fileList?.length - 1]?.originFileObj
        );
        setLoading(false);
        setImageUrl(url);
      }
    );
  };
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Invalid Uplaod, You can only upload image files!");
    }
    return isImage;
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Picture
      </div>
    </button>
  );
  const onFinish = async (values) => {
    // if (!imageObject) {
    //   swal("Error", "Profile Image is Required", "error");
    //   return;
    // }
    setLoading(true);
    let data = new FormData();
    data.append("email", values?.email);
    data.append("password", values?.password);
    data.append("firstName", values?.firstName);
    data.append("lastName", values?.lastName);
    data.append("phone", values?.mobile);
    data.append("isAdmin", false);
    // data.append("gender", values?.gender);
    // data.append(
    //   "dateOfBirth",
    //   moment(values?.dateOfBirth?.$d).format("YYYY-MM-DD")
    // );
    data.append("image", imageObject);
    Post(USER_AUTH.signup, data, null, null, "multipart")
      .then((response) => {
        setLoading(false);
        dispatch(
          addUser({ user: response.data?.user, token: response.data?.token })
        );
        swal("Success!", response?.message, "success");
        navigate("/signIn");
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        setLoading(false);
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <>
      {/* <Header /> */}
      <Row
        justify="center"
        style={{
          backgroundImage: `url('${ImageUrl("register-back.png")}')`, // Setting background color to black with 90% opacity
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="flex items-center justify-center min-h-screen"
      >
        <Col xl={12} md={18} xs={22} className="my-52 max-sm:my-32">
          <div className="flex flex-col justify-center items-center bg-white rounded-lg py-8 px-8 max-lg:px-2 ">
            <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
              Register
            </h3>
            <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
              Fill Out This form to sign up
            </p>
            <Form
              form={form}
              name="normal_login"
              onFinish={onFinish}
              layout="vertical"
              className="w-full px-8 max-xl:px-2"
            >
              <Row justify="center" gutter={[16, 16]}>
                <Col
                  lg={24}
                  md={24}
                  xs={24}
                  className="upload-img"
                  style={{ textAlign: "center" }}
                >
                  <Upload
                    name="image"
                    showUploadList={false}
                    style={{ position: "relative" }}
                    onChange={handleChangepro}
                    beforeUpload={beforeUpload}
                  >
                    {" "}
                    <div
                      style={{
                        height: "150px",
                        width: "150px",
                        borderRadius: "100%",
                        border: "1px dotted gray",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt="avatar"
                          style={{
                            maxWidth: "100%",
                            height: "150px",
                            objectPosition: "center",
                            objectFit: "cover",
                            borderRadius: "100%",
                          }}
                        />
                      ) : (
                        uploadButton
                      )}
                    </div>{" "}
                  </Upload>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    name="firstName"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        First Name
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input your first name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="First Name"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    name="lastName"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Last Name
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input your last name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Last Name"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                      type="text"
                    />
                  </Form.Item>
                </Col>
              </Row>
              {/* <Row justify="center" gutter={[16, 16]}>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Gender
                      </p>
                    }
                    name="gender"
                    rules={[
                      {
                        required: true,
                        message: "Please select Gender",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                    >
                      <Select.Option value="MALE">Male</Select.Option>
                      <Select.Option value="FEMALE">Female</Select.Option>
                      <Select.Option value="OTHERS">Others</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Date Of Birth
                      </p>
                    }
                    name="dateOfBirth"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your Date Of Birth!",
                      },
                    ]}
                  >
                    <DatePicker className="h-12 w-full text-sm font-euclid bg-gray-100 max-sm:text-xs" />
                  </Form.Item>
                </Col>
              </Row> */}
              <Row justify="center" gutter={[16, 16]}>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    name="email"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Email Address
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input your email address!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Email Address"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      autoComplete={false}
                      type="email"
                    />
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Phone Number
                      </p>
                    }
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your phone number!",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      size="large"
                      placeholder="Enter Phone Number"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      style={{ MozAppearance: "textfield" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center" gutter={[16, 16]}>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    name="password"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Password
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Password"
                      className="h-12 text-sm font-euclid bg-gray-100 "
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    name="confirmPassword"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Confirm Password
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Confirm your password!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("The two passwords do not match!")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm Password"
                      className="h-12 text-sm font-euclid bg-gray-100"
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Col md={12}>
                  <Form.Item className="self-center text-center">
                    <Button
                      htmlType="submit"
                      className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-white px-14 h-[50px] hover:text-customBrown text-center text-sm"
                    >
                      {loading ? "LOADING..." : "Register"}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
              {/* <Row justify="center" gutter={[16, 16]}>
                <Col md={12} sm={12} xs={24} className="flex justify-center">
                  <button className="uppercase bg-[#1877F2] hover:bg-white hover:border-[#1877F2] hover:border-2 font-urban font-bold text-white px-14 max-xl:px-4 h-[50px] hover:text-[#1877F2] text-center text-sm rounded-lg flex justify-center items-center max-xl:text-[10px] max-sm:text-sm max-sm:w-full">
                    <img
                      src={ImageUrl("face-circular.png")}
                      alt="facebook"
                      className="mr-2"
                    />
                    {loading ? "LOADING..." : "Signup with Facebook"}
                  </button>
                </Col>
                <Col md={12} sm={12} xs={24} className="flex justify-center">
                  <button className="uppercase bg-[#D9D9D9] hover:bg-white hover:border-[#D9D9D9] hover:border-2 font-urban font-bold text-black px-14 max-xl:px-4 h-[50px] hover:text-black text-center text-sm rounded-lg flex justify-center items-center max-xl:text-[10px] max-sm:text-sm max-sm:w-full">
                    <img
                      src={ImageUrl("google.png")}
                      alt="google"
                      className="mr-2"
                    />
                    {loading ? "LOADING..." : "Signup with Google"}
                  </button>
                </Col>
              </Row> */}
              <Row justify="center">
                <Link
                  to="/signIn"
                  className="font-euclid text-black text-sm border-b-2 border-black font-semibold mt-4 hover:text-black"
                >
                  Back to Sign In
                </Link>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Register;
